"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const statusColors = {
  GREEN: 'green',
  ORANGE: 'orange',
  RED: 'red',
  GREY: 'grey'
};

const Status = ({
  statusColor,
  className,
  prefix,
  small,
  label,
  statusDotPosition
}) => {
  const classes = (0, _classnames.default)(`${prefix}status`, className, `${prefix}status--${statusColor}`, label && `${prefix}status--labelled ${prefix}status--${statusDotPosition}`, small && `${prefix}status--small`);
  return _react.default.createElement("span", {
    className: classes
  }, _react.default.createElement("span", {
    className: `${prefix}status__dot`
  }), label && _react.default.createElement("p", {
    className: `${prefix}status__label`
  }, label));
};

Status.defaultProps = {
  prefix: '',
  statusColor: 'grey',
  statusDotPosition: 'leading'
};
var _default = Status;
exports.default = _default;